import { useMutation } from '@tanstack/react-query';
import { updateDashboardMeta } from '@src/api/dashboards';

function useUpdateDashboardMeta() {
  const updateMetaMutation = useMutation(updateDashboardMeta);

  return { updateMetaMutation };
}

export default useUpdateDashboardMeta;